<template lang="pug">
  v-container.shopcms-container.pt-0.px-0(fluid)
    //- Dialogs create
    v-dialog(v-if="createPost" :value='createPost' max-width='1024px' :fullscreen='isMobile' )
      createPostComponent( :key='tabnumber' @close="createPost = false" :currentContext="currentContext")
    v-dialog(v-if="updatePost" :value='updatePost'  max-width='1024px'  :fullscreen='isMobile' )
      updatePostComponent(@close="updatePost = false" :currentContext="currentContext")
    //- Content
    v-card.rounded-card.elevation-5.px-5
      v-card-title.justify-center.main-title-primary
        | Personalización
        v-btn(absolute small fab right color="#008e95" v-if="tabnumber == 1" @click="newItem")
          v-icon mdi-plus
      v-row.pt-5
        v-tabs(v-model="tabnumber" background-color="white" show-arrows color="#008e95" slider-color="white")
          v-tab {{$t('shops.virtual_shop.menus_titles.details_store')}}
          v-tab Multimedia
          v-tab Banner y Colores
          v-tab Productos
          //- v-tab Acerca de
          //- v-tab Posts
          v-tab-item(v-for="n in 4" :key="n")
            //- Details
            template(v-if='tabnumber === 0')
              //v-row.pt-6
                v-col(cols="4")
                  p.text-center {{$t('shops.virtual_shop.scope_store')}}
                v-col.mt-3(cols="8")
                  v-slider(v-model="rangeShop" color="#008e95" :max="10" thumb-label="always")
              v-row
                v-col.pt-0.px-5(cols="12" xs="12" sm="6" md="6")
                  v-text-field(prepend-inner-icon="mdi-hand-coin" prefix="$" v-model="shopForm.domicileValue" type="number" min=0)
                    template(v-slot:label)
                      span {{$t('shops.virtual_shop.price_delivery')}}
                v-col.pt-0.px-5(cols="12" xs="12" sm="6" md="6")
                  v-text-field(prepend-inner-icon="mdi-hand-coin" prefix="$" v-model="shopForm.minOrderValue" type="number" min=0)
                    template(v-slot:label)
                      span {{$t('shops.virtual_shop.minium_value_delivery')}}
                v-col.pt-0.px-5(cols="12")
                  v-textarea(v-model="shopForm.description" :label="$t('shops.virtual_shop.descp')" counter="150")
            //- Multimedia
            v-col(cols="12" v-if='tabnumber === 1')
              Multimedia(:multimedia="multimedia" :newItem="newMultimedia" @addedMultimedia="newMultimedia = false")
            //- Colors
            v-col(cols="12" v-if='tabnumber === 2')
              BannerColors(:colors="virtualShop.colors" :banner="virtualShop.banner" @uploadBanner="uploadBanner")
            //- Products
            v-col(cols="12" v-if='tabnumber === 3')
              SelectProducts
            //- About
            //- template(v-if='tabnumber === 1')
              template(v-if='about.length > 0')
                v-col(v-for="(i, index) in about" :key="index" cols="12" md="4"  )
                  v-card.mx-auto(max-width="400")
                    v-img.white--text.align-end(height="200px" :src="i.image")
                      v-card-title.custom-text {{i.title}}
                    v-card-subtitle.pb-0 {{i.type}}
                    v-card-text.text--primary
                      div {{i.subject}}
                    v-card-actions
                      v-btn(color="orange" text="" @click="openPostModal(i.id)")
                        | Vista Previa
                      v-btn(color="orange" text="" @click="updatePostModal(i.id)")
                        v-icon mdi-pen
                        | editar
                      v-btn(fab='', dark='', small='', color='red' @click='openDeleteModal(i.id)')
                        v-icon mdi-delete
              noResults(v-else :title="noResultsTexts[0]" :description="noResultsTexts[1]")
            //- Post
            //- template(v-if='tabnumber === 2')
              template(v-if='posts.length > 0')
                v-col(v-for="(i, index) in posts" :key="index" cols="12" md="4"  )
                  v-card.mx-auto(max-width="400")
                    v-img.white--text.align-end(height="200px" :src="i.image")
                      v-card-title.custom-text {{i.title}}
                    v-card-subtitle.pb-0 {{i.type}}
                    v-card-text.text--primary
                      div {{i.subject}}
                    v-card-actions
                      v-btn(color="orange" text="" @click="openPostModal(i.id)")
                        | Vista Previa
                      v-btn(color="orange" text="" @click="updatePostModal(i.id)")
                        v-icon mdi-pen
                        | editar
                      v-btn(fab='', dark='', small='', color='red' @click='openDeleteModal(i.id)')
                        v-icon mdi-delete
              noResults(v-else :title="noResultsTexts[0]" :description="noResultsTexts[1]")
    //- oold
    //- v-container(style="max-width: 1440px;").pa-0
      v-dialog( v-model='confirmationDialog' width="300px" persistent)
        v-card.pa-2
          v-card-title.headline Eliminar post
          v-card-text
            | Estas seguro de eliminar el contenido
          v-card-actions.justify-center
            v-btn.px-3(color='green darken-1', flat='', @click.native='confirmationDialog = false') No, cancelar
            v-btn.px-3(color='red darken-1', flat='', @click.native='deleteItem(currentItem.id)') Si, eliminar
      v-dialog(  :value='updatePost'  max-width='1024px'  :fullscreen='isMobile' )
        div(style ='position:relative; height: 100%; max-width:100%; overflow-x: hidden;')
          updatePostComponent(@close="updatePost = false" :currentContext="currentContext")
      v-dialog(  :value='createPost'  max-width='1024px'  :fullscreen='isMobile' )
        div(style ='position:relative; height: 100%; max-width:100%; overflow-x: hidden;')
          createPostComponent( :key='tabnumber' @close="createPost = false" :currentContext="currentContext")
      v-dialog(  :value='openPost'  max-width='600px'  :fullscreen='isMobile' )
        div(style ='position:relative; height: 100%; max-width:100%; overflow-x: hidden;')
          v-speed-dial.mt-2( style='z-index:9999', absolute right  direction='left')
            v-btn(small slot='activator'  color='blue darken-2' dark fab)
              v-icon mdi-more_horiz
              v-icon mdi-close
            v-btn(fab='', dark='', small='', color='green' @click.stop = 'updatePostModal(currentItem.id)')
              v-icon mdi-pen
            v-btn(fab='', dark='', small='', color='red' @click.stop = 'openDeleteModal(currentItem.id)')
              v-icon mdi-delete
        div(style ='position:relative; height: 100%; max-width:100%;')
          v-btn.mt-2.ml-2(medium light fab='', absolute, left style='z-index:9999'  @click.native='openPost = false')
            v-icon mdi-close
          itemComponent(:currentContext="currentContext" :postLoading="postLoading")
      v-card(v-if="!isMobile")
        v-toolbar(sticky dense="")
          v-spacer
          v-btn(absolute="" dark="" fab="" top="" right="" color="pink" v-if="tabnumber === 2 || tabnumber === 1 || (tabnumber === 0 && about.length === 0)" @click="newItem")
            v-icon mdi-plus
        v-tabs(v-model="tabnumber" background-color="white" color="deep-purple accent-4" show-arrows)
          v-tab Acerca de
          v-tab Posts
          v-tab Multimedia
          v-tab {{$t('shops.virtual_shop.menus_titles.details_store')}}
          v-tab-item(v-for="n in 4" :key="n" :style="isMobile ? '':'max-width: 60vw;'")
            v-row
              template(v-if='tabnumber === 0')
                template(v-if='about.length > 0')
                  v-col(v-for="(i, index) in about" :key="index" cols="12" md="4"  )
                    v-card.mx-auto(max-width="400")
                      v-img.white--text.align-end(height="200px" :src="i.image")
                        v-card-title.custom-text {{i.title}}
                      v-card-subtitle.pb-0 {{i.type}}
                      v-card-text.text--primary
                        div {{i.subject}}
                      v-card-actions
                        v-btn(color="orange" text="" @click="openPostModal(i.id)")
                          | Vista Previa
                        v-btn(color="orange" text="" @click="updatePostModal(i.id)")
                          v-icon mdi-pen
                          | editar
                        v-btn(fab='', dark='', small='', color='red' @click='openDeleteModal(i.id)')
                          v-icon mdi-delete
                noResults(v-else :title="noResultsTexts[0]" :description="noResultsTexts[1]")
              template(v-if='tabnumber === 1')
                template(v-if='posts.length > 0')
                  v-col(v-for="(i, index) in posts" :key="index" cols="12" md="4"  )
                    v-card.mx-auto(max-width="400")
                      v-img.white--text.align-end(height="200px" :src="i.image")
                        v-card-title.custom-text {{i.title}}
                      v-card-subtitle.pb-0 {{i.type}}
                      v-card-text.text--primary
                        div {{i.subject}}
                      v-card-actions
                        v-btn(color="orange" text="" @click="openPostModal(i.id)")
                          | Vista Previa
                        v-btn(color="orange" text="" @click="updatePostModal(i.id)")
                          v-icon mdi-pen
                          | editar
                        v-btn(fab='', dark='', small='', color='red' @click='openDeleteModal(i.id)')
                          v-icon mdi-delete
                noResults(v-else :title="noResultsTexts[0]" :description="noResultsTexts[1]")
              v-col(cols="12" v-if='tabnumber === 2')
                Multimedia(:multimedia="multimedia" :newItem="newMultimedia" @addedMultimedia="newMultimedia = false")
              v-col(v-if='tabnumber === 3' cols="12")
                v-card(flat="")
                  // Detalles de tienda
                  v-card-text
                    v-row
                      v-col(cols="12")
                        h3 {{$t('shops.virtual_shop.menus_titles.details_store')}}
                      v-col(cols="12")
                        p(class="text-center") {{$t('shops.virtual_shop.scope_store')}}
                        v-subheader.pl-0
                        v-slider(v-model="rangeShop" :max="10" thumb-label="always")
                      v-col(cols="12")
                        v-textarea(v-model="shopForm.description" outlined :label="$t('shops.virtual_shop.descp')")
                        v-text-field(v-model="shopForm.domicileValue" outlined :label="$t('shops.virtual_shop.price_delivery')" prefix="$" type="number" min=0)
                        v-text-field(v-model="shopForm.minOrderValue" outlined :label="$t('shops.virtual_shop.minium_value_delivery')" prefix="$" type="number" min=0)
      //- template(v-if="isMobile")
        v-list(two-line="" v-if="currentOption === ''").pa-0
          v-list-item(@click="currentOption = 0")
            v-list-item-avatar
              v-icon mdi-information-variant
            v-list-item-content
              v-list-item-title Acerca de
          v-list-item(@click="currentOption = 1")
            v-list-item-avatar
              v-icon mdi-post
            v-list-item-content
              v-list-item-title Posts
          v-list-item(@click="currentOption = 2")
            v-list-item-avatar
              v-icon mdi-postage-stamp
            v-list-item-content
              v-list-item-title Multimedia
          v-list-item(@click="currentOption = 3")
            v-list-item-avatar
              v-icon mdi-details
            v-list-item-content
              v-list-item-title {{$t('shops.virtual_shop.menus_titles.details_store')}}
        v-row
          v-btn(dark="" small text @click="currentOption = ''" v-if="currentOption !== ''").fixed-back-button
            v-icon(size="25") mdi-chevron-left
          div.justify-end
            v-btn.mt-4(absolute="" dark="" fab="" top="" right="" color="pink" v-if="currentOption === 2 || currentOption === 1 || (currentOption === 0 && about.length === 0)" @click="newItem")
              v-icon mdi-plus
          noResults(v-if="currentOption !== '' && currentOption === 0 && about.length === 0" :title="noResultsTexts[0]" :description="noResultsTexts[1]")
          noResults(v-if="currentOption !== '' && currentOption === 1 && posts.length === 0" :title="noResultsTexts[0]" :description="noResultsTexts[1]")
          v-col(v-for="(i, index) in about" v-if='currentOption === 0' :key="index" cols="12" md="4"  ).mt-4
            v-card.mx-auto(max-width="400")
              v-img.white--text.align-end(height="200px" :src="i.image")
                v-card-title.custom-text {{i.title}}
              v-card-subtitle.pb-0 {{i.type}}
              v-card-text.text--primary
                div {{i.subject}}
              v-card-actions
                v-btn(color="orange" text="" @click="openPostModal(i.id)")
                  | Vista Previa
                v-btn(color="orange" text="" @click="updatePostModal(i.id)")
                  v-icon mdi-pen
                  | editar
                v-btn(fab='', dark='', small='', color='red' @click='openDeleteModal(i.id)')
                  v-icon mdi-delete
          v-col(v-for="(i, index) in posts" v-if='currentOption === 1' :key="index" cols="12" md="4"  ).mt-4
            v-card.mx-auto(max-width="400")
              v-img.white--text.align-end(height="200px" :src="i.image")
                v-card-title.custom-text {{i.title}}
              v-card-subtitle.pb-0 {{i.type}}
              v-card-text.text--primary
                div {{i.subject}}
              v-card-actions
                v-btn(color="orange" text="" @click="openPostModal(i.id)")
                  | Vista Previa
                v-btn(color="orange" text="" @click="updatePostModal(i.id)")
                  v-icon mdi-pen
                  | editar
                v-btn(fab='', dark='', small='', color='red' @click='openDeleteModal(i.id)')
                  v-icon mdi-delete
          v-col(v-if='currentOption === 2' cols="12").mt-8
            Multimedia(:multimedia="multimedia" :newItem="newMultimedia" @addedMultimedia="newMultimedia = false")
          v-col(v-if='currentOption === 3' cols="12")
            v-card(flat="")
              // Detalles de tienda
              v-card-text
                v-row
                  v-col(cols="12")
                    h3 {{$t('shops.virtual_shop.menus_titles.details_store')}}
                  v-col(cols="12")
                    p(class="text-center") {{$t('shops.virtual_shop.scope_store')}}
                    v-subheader.pl-0
                    v-slider(v-model="rangeShop" :max="10" thumb-label="always")
                  v-col(cols="12")
                    v-textarea(v-model="shopForm.description" outlined :label="$t('shops.virtual_shop.descp')")
                    v-text-field(v-model="shopForm.domicileValue" outlined :label="$t('shops.virtual_shop.price_delivery')" prefix="$" type="number" min=0)
                    v-text-field(v-model="shopForm.minOrderValue" outlined :label="$t('shops.virtual_shop.minium_value_delivery')" prefix="$" type="number" min=0)
</template>

<script>
  import updatePostComponent from '@/views/custom/shops-content/UpdatePost'
  import createPostComponent from '@/views/custom/shops-content/CreatePost'
  import itemComponent from '@/views/custom/shops-content/Post'
  import Multimedia from '@/views/custom/shops-content/Multimedia'

  export default {
    components: {
      itemComponent,
      updatePostComponent,
      createPostComponent,
      Multimedia,
      BannerColors: () => import('@/views/custom/shops-content/BannerColors'),
      SelectProducts: () => import('@/views/custom/shops-content/SelectProducts'),
      noResults: () => import('@/components/custom/NoResults.vue'),
    },
    props: {
      rangeShop: {
        type: Number,
        default: 0,
      },
      shopForm: {
        type: Object,
        default: () => {
          return {
            description: '',
            domicileValue: 0,
            minOrderValue: 0,
          }
        },
      },
      virtualShop: {
        type: Object,
        default: () => {
          return {
            id: '',
            name: '',
            address: '',
            addressgoogle: '',
            location: '',
            uid: '',
            img: '',
            categories: '',
            type: '',
            scope: '',
            mainCategorie: '',
            banner: '',
            colors: {
              primary: '#008e95FF',
              secondary: '#008e95FF',
            },
          }
        },
      },
    },
    data () {
      return {
        fab: false,
        confirmationDialog: false,
        createPost: false,
        openPost: false,
        updatePost: false,
        tabnumber: 0,
        transition: 'slide-y-reverse-transition',
        postLoading: false,
        currentOption: '',
        newMultimedia: false,
      }
    },
    computed: {
      noResultsTexts () {
        const vm = this
        if (vm.currentOption === 0 || vm.tabnumber === 0) {
          return [
            'No tienes información "Acerca de" la tienda',
            'En el "Acerca de" puedes contarnos más acerca de tu tienda.',
          ]
        } else if (vm.currentOption === 1 || vm.tabnumber === 1) {
          return [
            'No tienes posts',
            'En los "Posts" puedes crear articulos para los usuarios de tu tienda.',
          ]
        } else if (vm.currentOption === 2 || vm.tabnumber === 2) {
          return [
            'No tienes multimedia',
            'En la "Multimedia" puedes mostrar imagenes de tu tienda y tus articulos para los usuarios que te visiten.',
          ]
        } else {
          return ['', '']
        }
      },
      currentContext () {
        if (this.currentOption === '') {
          switch (this.tabnumber) {
            case 0 :
              return `users/${this.user}/shops/${this.shop}/about`
            case 1 :
              return `users/${this.user}/shops/${this.shop}/posts`
            case 2:
              return `users/${this.user}/shops/${this.shop}/multimedia`
            default:
              return `users/${this.user}/shops/${this.shop}/posts`
          }
        } else {
          switch (this.currentOption) {
            case 0 :
              return `users/${this.user}/shops/${this.shop}/about`
            case 1 :
              return `users/${this.user}/shops/${this.shop}/posts`
            case 2:
              return `users/${this.user}/shops/${this.shop}/multimedia`
            default:
              return `users/${this.user}/shops/${this.shop}/posts`
          }
        }
      },
      isMobile () {
        return window.innerWidth < 1024
      },
      shop () {
        return this.$store.getters['shops/getCurrentItem'].id
      },
      user () {
        return this.$store.getters['shops/getCurrentItem'].ownerId
      },
      currentItem () {
        return this.$store.getters['cms/getCurrentPost']
      },
      posts () {
        return this.$store.getters['cms/getShopPosts']
      },
      about () {
        // console.log(this.$store.getters['cms/getShopAbout'])
        return this.$store.getters['cms/getShopAbout']
      },
      multimedia () {
        return this.$store.getters['cms/getShopMultimedia']
      },
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        const vm = this
        vm.$store.commit('cms/setLoading', true)

        vm.$store.dispatch('cms/loadItems', 'shop-posts').then(() => {
          // console.log('Post de la tienda cargados')
          vm.$store.commit('cms/setLoading', false)
        })
        vm.$store.dispatch('cms/loadItems', 'shop-about').then(() => {
          // console.log('About Us de la tienda cargado')
          vm.$store.commit('cms/setLoading', false)
        })
        vm.$store.dispatch('cms/loadItems', 'shop-multimedia').then(() => {
          // console.log('Multimedia de la tienda cargada')
          vm.$store.commit('cms/setLoading', false)
        })
      },
      uploadBanner (file) {
        this.virtualShop.banner = file
      },
      updatePostModal (id) {
        const vm = this
        this.$store.dispatch('cms/getItem', { context: vm.currentContext, id: id }).then(function () {
          vm.updatePost = true
        })
      },
      openPostModal (id) {
        const vm = this
        vm.postLoading = true
        vm.$store.dispatch('cms/getItem', { context: vm.currentContext, id: id }).then(function () {
          vm.openPost = true
          vm.postLoading = false
        })
      },
      newItem () {
        if (this.tabnumber === 1 || this.currentOption === 1) {
          this.newMultimedia = true
        } else {
          this.openCreatorModal()
        }
      },
      openCreatorModal () {
        this.createPost = true
      },
      openDeleteModal (id) {
        const vm = this
        vm.$store.dispatch('cms/getItem', { context: vm.currentContext, id: id }).then(function () {
          vm.confirmationDialog = true
        })
      },
      deleteItem (id) {
        const vm = this
        this.$store.dispatch('cms/deleteItem', { context: vm.currentContext, id: id }).then(function () {
          vm.confirmationDialog = false
        },
        )
      },
    },
  }
</script>
<style lang="scss">
  .shopcms-container{
    .rounded-card{
      border-radius: 20px;
      height: 500px !important;
      overflow-y: scroll;
      overflow-x: hidden;
      &__title{
        position: absolute;
        font-size: 15px;
        font-weight: bold;
      }
      overflow-y: scroll !important;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
</style>
